import { useEffect } from "react";

const MobileApp = () => {
    useEffect(() => {
        window.location.href = 'ticki://';
    }, []);
    return (
        <div>
            Opening mobile App
        </div>
    )
}

export default MobileApp;